/**
 * Live TV page: video poster visibility and Last 24 tabs.
 * Expects block root to have data-live-tv-page-id and data-last-24-tabs-id.
 */
(function() {
  function run() {
    var blockRoot = document.querySelector('[data-live-tv-page-id]');
    if (!blockRoot) return;

    var sectionId = blockRoot.getAttribute('data-live-tv-page-id');
    var last24Id = blockRoot.getAttribute('data-last-24-tabs-id');
    var section = sectionId ? document.getElementById(sectionId) : null;
    var tabsRoot = last24Id ? document.getElementById(last24Id) : null;

    if (section) {
      var video = section.querySelector('.live-tv-page__video');
      var poster = section.querySelector('[data-poster-overlay]');
      var posterPlay = section.querySelector('[data-poster-play]');
      var autoplay = section.getAttribute('data-autoplay') === 'true';
      var autoplayAttempted = false;
      function tryAutoplay() {
        if (autoplayAttempted || !autoplay || !video || !video.paused) return;
        autoplayAttempted = true;
        playVideo();
      }
      function updatePosterVisibility() {
        if (!poster || !video) return;
        // Don't flash the poster/pause state while the tab is hidden —
        // background-tab throttling can briefly pause the live stream (IWS-652).
        if (document.hidden) return;
        var show = video.paused || video.readyState < 2;
        poster.classList.toggle('is-visible', show);
        poster.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      function playVideo() {
        if (!video) return;
        video.muted = true;
        video.play().catch(function() {});
      }
      if (video) {
        video.addEventListener('play', updatePosterVisibility);
        video.addEventListener('pause', updatePosterVisibility);
        video.addEventListener('waiting', updatePosterVisibility);
        video.addEventListener('canplay', updatePosterVisibility);
        video.addEventListener('loadeddata', updatePosterVisibility);
        video.addEventListener('canplay', tryAutoplay);
        video.addEventListener('loadeddata', tryAutoplay);
        // Re-evaluate once the tab is visible again (player may auto-resume,
        // so wait a tick before deciding whether to show the poster).
        document.addEventListener('visibilitychange', function() {
          if (!document.hidden) setTimeout(updatePosterVisibility, 300);
        });
        if (poster) poster.classList.add('is-visible');
      }
      if (posterPlay && video) {
        posterPlay.addEventListener('click', playVideo);
        posterPlay.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); playVideo(); }
        });
      }
      updatePosterVisibility();
    }

    if (tabsRoot) {
      var tabs = tabsRoot.querySelectorAll('.last-24-tabs__tab');
      var panels = tabsRoot.querySelectorAll('.last-24-tabs__panel');
      function selectTab(index) {
        tabs.forEach(function(t, i) {
          var selected = i === index;
          t.setAttribute('aria-selected', selected);
          t.classList.toggle('last-24-tabs__tab--selected', selected);
        });
        panels.forEach(function(p, i) {
          var selected = i === index;
          p.hidden = !selected;
          p.classList.toggle('is-selected', selected);
        });
      }
      tabs.forEach(function(tab, index) {
        tab.addEventListener('click', function() { selectTab(index); });
        tab.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); selectTab((index + 1) % tabs.length); tabs[(index + 1) % tabs.length].focus(); }
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); selectTab((index - 1 + tabs.length) % tabs.length); tabs[(index - 1 + tabs.length) % tabs.length].focus(); }
          else if (e.key === 'Home') { e.preventDefault(); selectTab(0); tabs[0].focus(); }
          else if (e.key === 'End') { e.preventDefault(); selectTab(tabs.length - 1); tabs[tabs.length - 1].focus(); }
        });
      });
      selectTab(0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
